/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $emptySelector, $triggerSelector;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      triggerSelector    : null,
      emptySelector      : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $emptySelector     = $(settings.emptySelector);
    $triggerSelector   = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    
    
    if ($cartCountSelector) {
      var itemQty = 0;
      var isItemFabric = false;
      $.each(cart.items, function(index, cartItem) {       
        if(cartItem.variant_title != null){
          console.log(cartItem)
          var varArr = cartItem.variant_title.split("/");
          var isFabricVariant = false;
          $(varArr).each(function(vindex, vtitle){
            if($.trim(vtitle) == "Fabric"){
              isFabricVariant = true;
              isItemFabric = true;
            }
          });
          
          if(isFabricVariant){
            itemQty += (cartItem.quantity/10);
          }else{
            itemQty += cartItem.quantity;
          }
        }else{
          itemQty += cartItem.quantity;
        }
      });
      
      
      
      
      
     // $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(isItemFabric) itemQty = itemQty.toFixed(1); 
       $cartCountSelector.html(itemQty).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $(settings.emptySelector).show();
      $(settings.triggerSelector).removeClass('js-cart-full');
      cartCallback(cart);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.triggerSelector).addClass('js-cart-full');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_240x240_crop_center$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      var isItemFabric = false;
      if(cartItem.variant_title != null){
        var varArr = cartItem.variant_title.split("/");
        $(varArr).each(function(vindex, vtitle){
          if($.trim(vtitle) == "Fabric"){
            isItemFabric = true;
          }
        });
      }
      
      var itemAdd, itemMinus, itemQty;
      if(isItemFabric){
        itemQty = (cartItem.quantity / 10);
        itemAdd = itemAdd + 0.1;
        itemMinus = itemMinus - 0.1;
      }else{
        itemQty = cartItem.quantity;
        itemAdd = itemAdd + 1;
        itemMinus = itemMinus - 1;
      }
      

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: itemAdd,
        itemMinus: itemMinus,
        itemQty: itemQty,
        itemOriginalQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        isItemFabric: isItemFabric
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));
    
    if($(".ajaxcart__products .ajaxcart__product").length){
      $(".ajaxcart__products .ajaxcart__product").each(function(){
        if($(this).hasClass("cart_fabric_item")){
          var vMeter = parseFloat($(this).find(".ajaxcart__qty input").val());
          var vCM = parseInt(vMeter * 10);
         	$(this).find(".ajaxcart__qty").after("<span class='meter_info'>"+vMeter+" <span>Metres</span></span>");
        }
      });
    }
    for(var i=0; i < data.items.length ; i++){
      var val = data.items[i].itemQty;
      if(val < 1 ){
        $('.ajaxcart__products .meter_info_error').remove()
        $('.ajaxcart__products').append('<span class="meter_info_error">Please Enter minimum amount of cut is 1m</span>')
        $('.ajaxcart__button').css({'opacity':'0.6','pointer-events': 'none'})
//         setTimeout(function(){
//           $('.meter_info_error').remove()
//         },3000)
        break;
      } 
    }
 
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
    
    
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseFloat($qtySelector.val());

      //var qty = validateQty(qty);

      // Add or subtract from the current quantity
      var qtyDiff;
      if($qtySelector.attr("data-diff") != undefined){
        qtyDiff = parseFloat($qtySelector.attr("data-diff"));
      }else{
        qtyDiff = 1;
      }
      
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += qtyDiff;
      } else {
        qty -= qtyDiff;
        if (qty <= 0){ qty = 0; }
      }

      
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        if(qty != 0 && qtyDiff == 0.1){
          if(qty < 1) qty = parseInt(qty*10+0.1) ;
          else qty = parseInt(qty*10);
        }else{
          qty = parseInt(qty);
        }
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseFloat($el.val());
      
      var qtyDiff;
      if($el.attr("data-diff") != undefined){
        qty = parseInt(qty*10);
      }else{
        qty = parseInt(qty);
      }

      //var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
       $('.ajaxcart__products .meter_info_error').remove()
      var val = $(this).val();
     
     
       
        if(val < 1 ){
          $('.ajaxcart__products .meter_info_error').remove()
          $('.ajaxcart__products').append('<span class="meter_info_error">Please Enter minimum amount of cut is 1m</span>')
          $('.ajaxcart__button').css({'opacity':'0.6','pointer-events': 'none'})
//           setTimeout(function(){
//             $('.meter_info_error').remove()
//           },5000)
        }else{
          $('.ajaxcart__button').removeAttr('style')
        }
      
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    }); 
    
    // Remove line item
    $('body').on('click', '.ajaxcart__remove-line-item', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = 0;

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
       
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseFloat($qtySelector.val());

        var Arr = $(this).parents('.cart__row').find('.cart__product-meta').text();
        
        var isItemFabric = false;
        if(Arr != null || Arr != ''){
          var varArr = Arr.split("/");
          $(varArr).each(function(vindex, vtitle){
            if($.trim(vtitle) == "Fabric"){
              isItemFabric = true;
            }
          });
        }
		
        console.log(isItemFabric)
        
       // var qty = validateQty(qty);

        // Add or subtract from the current quantity
        var qtyDiff;
        if($qtySelector.attr("data-diff") != undefined){
          qtyDiff = parseFloat($qtySelector.attr("data-diff"));
        }else{
          qtyDiff = 1;
        }
        
        if ($el.hasClass('js-qty__adjust--plus')) {
          if(isItemFabric){
              qty += qtyDiff;
              $($el).closest('.js-qty:after').css('content', $qtySelector.val())
          }else{
              qty += qtyDiff;
          }
        } else {
          if(isItemFabric){
              if(qty >= 11){
                qty -= qtyDiff;
                if (qty < 1) qty = 1;
              }
          }else{
              qty -= qtyDiff;
              if (qty < 1) qty = 1;
          }
        }
        
        if(qtyDiff == 0.1){
          qty = qty.toFixed(1);
        }
        

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.addEventListener('load', function () {
    $('.cart__products .cart__product').each(function(){
        var Arr = $(this).find('.cart__row').find('.cart__product-meta').text();
            
        var isItemFabric = false;
        if(Arr != null || Arr != ''){
          var varArr = Arr.split("/");
          $(varArr).each(function(vindex, vtitle){
            if($.trim(vtitle) == "Fabric"){
              isItemFabric = true;
            }
          });
        }
        if(isItemFabric == true){
            $(this).find('.js-qty__num').hide();
            var val = $(this).find('.js-qty input.js-qty__num').val();
            $(this).find('.js-qty .js-qty__adjust--minus').after('<input type="text" class="custom-fabric" value="'+val+'">');
            var change_val = parseFloat($(this).find('.custom-fabric').attr('value'));
            change_val = Number(change_val/10)
            console.log(change_val)
            $(this).find('.js-qty .custom-fabric').attr('value', change_val);
        }
    })

    var custom_item_count = [];
    $('.upcart-cart-body .upcart-product-item').each(function(){
        var Arr = $(this).find('.upcart-item-option-value').text();
            
        var isItemFabric = false;
        if(Arr != null || Arr != ''){
          var varArr = Arr.split("/");
          $(varArr).each(function(vindex, vtitle){
            if($.trim(vtitle) == "Fabric"){
              isItemFabric = true;
            }
          });
        }
        if(isItemFabric == true){
            $(this).find('.upcart-product-quantity-input').hide();
            var val = $(this).find('input.upcart-product-quantity-input').val();
            $(this).find('.upcart-product-quantity-minus').after('<input type="text" class="custom-fabric" value="'+val+'">');
            var change_val = parseFloat($(this).find('.custom-fabric').val());
            change_val = Number(change_val/10)
            console.log(change_val)
            $(this).find('.custom-fabric').val(change_val);
            custom_item_count.push(change_val)
        }else{
            var val = $(this).find('input.upcart-product-quantity-input').val();
            custom_item_count.push(Number(val))
        }
        sumarray = custom_item_count.map(Number);              
        var total = sumarray.reduce(function(a,b){  return a+b },0)
        $('h2.upcart-header-text').text('Cart • '+total.toFixed(1))
    })
})


$(document).on('click', '.js-qty__adjust', function() {
    var Arr = $(this).closest('.cart__row').find('.cart__product-meta').text();
        
    var isItemFabric = false;
    if(Arr != null || Arr != ''){
      var varArr = Arr.split("/");
      $(varArr).each(function(vindex, vtitle){
        if($.trim(vtitle) == "Fabric"){
          isItemFabric = true;
        }
      });
    }
  
    if(isItemFabric == true){
        $(this).closest('.js-qty').find('input.js-qty__num').hide();
        var val = $(this).closest('.js-qty').find('input.js-qty__num').val();
        var change_val = parseFloat(val);
        change_val = Number(change_val/10)
        console.log(change_val)
        $(this).closest('.js-qty').find('.custom-fabric').val(change_val);
    }
})

$(document).on('mousedown tap', '.upcart-product-item>*', function() {
    setTimeout(function(){
      var custom_item_count = [];
      $('.upcart-cart-body .upcart-product-item').each(function () {
          var option = $(this).find('.upcart-item-option-value').html();
          var custom = $(this).find('.custom-fabric').val();
          if(option != undefined && custom == undefined){
            if(option.indexOf('Fabric') != -1){
                  $(this).find('.upcart-product-quantity-input').hide();
                  var val = $(this).find('input.upcart-product-quantity-input').val();
                  var change_val = parseFloat(val);
                  change_val = Number(change_val/10)
                  $(this).find('.upcart-product-quantity-minus').after('<input type="text" class="custom-fabric" value="'+change_val+'">');
            }
          }

          if(option != undefined){
            if(option.indexOf('Fabric') != -1){
                  var val = $(this).find('input.upcart-product-quantity-input').val();
                  var change_val = parseFloat(val);
                  change_val = Number(change_val/10)
                  custom_item_count.push(change_val)
            }else{
                var val = $(this).find('input.upcart-product-quantity-input').val();
                custom_item_count.push(Number(val))
            }
          }else{
              var val = $(this).find('input.upcart-product-quantity-input').val();
              custom_item_count.push(Number(val))
          }
      })
      sumarray = custom_item_count.map(Number);              
      var total = sumarray.reduce(function(a,b){  return a+b },0)
      $('h2.upcart-header-text').text('Cart • '+total.toFixed(1))
    }, 800)
})

$(document).on('mousedown tap', '.js-product-add', function() {
    setTimeout(function(){
      var custom_item_count = [];
      $('.upcart-cart-body .upcart-product-item').each(function () {
          var option = $(this).find('.upcart-item-option-value').html();
          var custom = $(this).find('.custom-fabric').val();
          if(option != undefined && custom == undefined){
            if(option.indexOf('Fabric') != -1){
                  $(this).find('.upcart-product-quantity-input').hide();
                  var val = $(this).find('input.upcart-product-quantity-input').val();
                  var change_val = parseFloat(val);
                  change_val = Number(change_val/10)
                  $(this).find('.upcart-product-quantity-minus').after('<input type="text" class="custom-fabric" value="'+change_val+'">');
            }
          }

          if(option != undefined){
            if(option.indexOf('Fabric') != -1){
                  var val = $(this).find('input.upcart-product-quantity-input').val();
                  var change_val = parseFloat(val);
                  change_val = Number(change_val/10)
                  custom_item_count.push(change_val)
            }else{
                var val = $(this).find('input.upcart-product-quantity-input').val();
                custom_item_count.push(Number(val))
            }
          }else{
              var val = $(this).find('input.upcart-product-quantity-input').val();
              custom_item_count.push(Number(val))
          }
      })
      sumarray = custom_item_count.map(Number);              
      var total = sumarray.reduce(function(a,b){  return a+b },0)
      $('h2.upcart-header-text').text('Cart • '+total.toFixed(1))
    }, 3500)
})